<template>
  <div :class="statusClasses">
    {{ score }}
  </div>
</template>

<script>
import { kebabCase } from 'lodash'

export default {
  name: 'BaseReportScore',

  props: {
    score: {
      required: true,
      type: String
    },
    status: {
      required: true,
      type: String
    }
  },

  computed: {
    statusClasses () {
      return kebabCase(this.status) === 'positive' ? 'text-success' : 'text-danger'
    }
  }
}
</script>
